// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"n6-z","displaySixCardTiles":"o6-z"};